// extracted by mini-css-extract-plugin
module.exports = {"layoutContainer":"Layout_layoutContainer__1Wraj","contentWrapper":"Layout_contentWrapper__20LnE","content":"Layout_content__214hS"};